import { defineMessages } from '@/hooks/useTranslation';

export default defineMessages({
  header: {
    title: {
      de: 'Shopware',
      en: 'Shopware'
    },
    description: {
      de: 'Professionelle Shopware-Entwicklung für Ihren E-Commerce Erfolg.',
      en: 'Professional Shopware development for your e-commerce success.'
    }
  }
}); 